import React from 'react';
import styled from '@emotion/styled';
import JobListSkeletonLoader from './JobList';
import HomePageSkeletonLoader from './HomePage';
import DefaultSkeletonLoader from './Default';
import ArticleDetailSkeletonLoader from './ArticleDetail';
import JobDetailSkeletonLoader from './JobDetail';
import EventListSkeletonLoader from './EventList';
import NewsFeedSkeletonLoader from './NewsFeed';
import MostReadSkeletonLoader from './MostRead';

export const SkeletonContainer = styled.div`
  display: flex;
  justify-content: start;
  align-items: stretch;
`;

export type SkeletonVariants =
  'articleDetail' |
  'eventList' |
  'homePage' |
  'jobDetail' |
  'jobList' |
  'mostRead' |
  'newsFeed';

interface SkeletonLoaderProperties {
  variant?: SkeletonVariants;
}

const loaders: Record<SkeletonVariants, JSX.Element> = {
  articleDetail: <ArticleDetailSkeletonLoader />,
  eventList: <EventListSkeletonLoader />,
  homePage: <HomePageSkeletonLoader />,
  jobDetail: <JobDetailSkeletonLoader />,
  jobList: <JobListSkeletonLoader />,
  mostRead: <MostReadSkeletonLoader />,
  newsFeed: <NewsFeedSkeletonLoader />,
};

const SkeletonLoader = ({ variant }: SkeletonLoaderProperties) => (
  variant ? loaders[variant] : <DefaultSkeletonLoader />
);

export default SkeletonLoader;
